import { ReactElement } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

interface ITopbarMenuLinks {
  title: string;
  icon: string;
  path: string;
  onclick?: () => void;
}

const TopbarMenuLinks = ({
  title,
  icon,
  path,
  onclick,
}: ITopbarMenuLinks): ReactElement => (
  <Link className="topbar__link" to={path} onClick={onclick}>
    <span className={`topbar__link-icon lnr lnr-${icon}`} />
    <p className="topbar__link-title">{title}</p>
  </Link>
);

TopbarMenuLinks.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onclic: PropTypes.func,
};

export default TopbarMenuLinks;
